import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { AppServicesConfigStatus, WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { AppServicesConfig, ServicesService } from 'app/shared/services';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-workspace-settings',
  template: `
    <kp-app-services-config
      (appStatusChanged)="onAppStatusChange($event)"
      [appServicesConfig]="appServicesConfig$ | async"
      [workspaceId]="id"
    ></kp-app-services-config>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class WorkspaceSettingsComponent implements OnInit {
  id: string;
  appServicesConfig$!: Observable<AppServicesConfig>;

  constructor(
    private _servicesService: ServicesService,
    private workspaceService: WorkspaceService,
  ) {
    this.id = this.workspaceService.getCurrentWorkspace().id;
    this.appServicesConfig$ = this._servicesService.appServicesConfigChanged$.pipe();
  }

  ngOnInit(): void {
    this._servicesService.fetchAppConfig();
  }

  onAppStatusChange(event: AppServicesConfigStatus): void {
    this._servicesService.changeWorkspaceService(event);
  }
}
